import type { Dayjs } from 'dayjs';
import {
  WeddingDateDisplayFormatEnum,
  WebsiteDatePublicPropType,
} from '../../../util/websiteDateUtil';

const formatDate = (websiteDate?: WebsiteDatePublicPropType<Dayjs>): string | undefined => {
  if (websiteDate?.displayFormat === WeddingDateDisplayFormatEnum.CUSTOM) {
    return websiteDate.customDateMessage;
  }

  if (websiteDate?.displayFormat === WeddingDateDisplayFormatEnum.RANGE) {
    const { weddingDateRangeStart, weddingDateRangeEnd } = websiteDate || {};
    const sameYear = weddingDateRangeStart?.get('year') === weddingDateRangeEnd?.get('year');
    const sameMonth =
      sameYear && weddingDateRangeStart?.get('month') === weddingDateRangeEnd?.get('month');
    if (sameMonth) {
      return `${weddingDateRangeStart?.format('MMMM')} ${weddingDateRangeStart?.format('D')} - 
${weddingDateRangeEnd?.format('D')}, ${weddingDateRangeEnd?.format('YYYY')}
              `;
    }
    if (sameYear) {
      return `${weddingDateRangeStart?.format('MMMM')} ${weddingDateRangeStart?.format('D')} - 
                ${weddingDateRangeEnd?.format('MMMM')} ${weddingDateRangeEnd?.format('D')}, 
                ${weddingDateRangeEnd?.format('YYYY')}`;
    }
    return `${weddingDateRangeStart?.format('MMMM DD, YYYY')}-${weddingDateRangeEnd?.format(
      'MMMM DD, YYYY'
    )}`;
  }
  return websiteDate?.weddingDate?.format('MMMM DD, YYYY');
};

export default formatDate;
